import './QuantitativeSamplesManagement.css';

import React, { useState } from 'react';
import { getAreaDisabledDataRanges } from '../../components/helper';
import { CommonInfo } from './QuantitativeObjectiveManagement';
import QuantitativeSamplesTable from './QuantitativeSamplesTable';
import QuantitativeSampleEditForm from '../../components/samples/QuantitativeSampleEditForm';

const QuantitativeSamplesManagement = ({ areaIndicator, onRefresh = null }) => {
    const [showSampleEditForm, setShowSampleEditForm] = useState(false);
    const [sampleSelected, setSampleSelected] = useState(null);

    const disabledDateRanges = getAreaDisabledDataRanges(areaIndicator.area);

    const handleSampleClick = (sample) => {
        setSampleSelected(sample);
        setShowSampleEditForm(true);
    };

    const handleSavedQuantitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    const handleDeletedQuantitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    return (
        <>
            <CommonInfo areaIndicator={areaIndicator} />
            <QuantitativeSamplesTable
                areaIndicator={areaIndicator}
                onSampleClick={handleSampleClick}
                onNewSample={() => {
                    setSampleSelected(null);
                    setShowSampleEditForm(true);
                }}
            />
            {
                showSampleEditForm &&
                <QuantitativeSampleEditForm
                    sample={sampleSelected}
                    planUUID={areaIndicator.area.plan.planUUID}
                    areaId={areaIndicator.area.areaId}
                    areaIndicatorId={areaIndicator.areaIndicatorId}
                    indicator={areaIndicator.indicatorDTO}
                    disabledDateRanges={disabledDateRanges}
                    onCancel={() => setShowSampleEditForm(false)}
                    onSave={handleSavedQuantitativeSample}
                    onDelete={handleDeletedQuantitativeSample}
                />
            }
        </>
    );
};

export default QuantitativeSamplesManagement;